import React, {useState} from "react";
import { Tooltip } from 'react-tooltip';
import useReadSystemUserList from "../../../../pages/customer/correspondent/detail/hooks/useReadSystemUserList";
import EmptyTableRow from "../../../../pages/common/EmptyTableRow";
import {BasicSearchType} from "../../../../types/common/basic";
import {SubmitHandler, useForm} from "react-hook-form";
import {ModalInnerConfirmType} from "../interface";
import {useModal} from "../../../../hooks";
import {SystemUserMapType, SystemUserType,} from "../../../../pages/customer/correspondent/detail/interface";
import PaginationSub from "../../pagination/PaginationSub";

export const SearchSystemUserInner = ({
                                          confirmCallback,
                                          cancelCallback,
                                          modalDepth,
                                      }: ModalInnerConfirmType<SystemUserType>) => {
    const defaultSearchValue = {
        limit: 10,
        pageNo: 1,
        keywordType: "0",
        keyword: "",
    };

    const {handleModal, resetModal} = useModal();

    const [selectItem, setSelectItem] = useState<SystemUserType | null>(null);

    const [searchOption, setSearchOption] =
        useState<BasicSearchType>(defaultSearchValue);

    const {data} = useReadSystemUserList({searchData: searchOption});

    const {register, handleSubmit} = useForm({
        defaultValues: searchOption,
    });

    const onSubmit: SubmitHandler<BasicSearchType> = (submitData) => {
        setSearchOption(submitData);
    };

    const onClose = () => {
        resetModal(modalDepth);
    };

    const onConfirm = () => {
        if (selectItem?.systemuserid) {
            confirmCallback(selectItem);
            onClose();
        } else {
            handleModal({
                isOpen: true,
                contents: "사용자를 선택해주세요.",
                type: "alert",
                depth: modalDepth + 1,
            });
        }
    };

    const onCancel = () => {
        onClose();
        cancelCallback && cancelCallback();
    };

    return (
        <>
            <form className="d-flex mb-15px" onSubmit={handleSubmit(onSubmit)}>
                <select className="form-select w-120px" {...register("keywordType")}>
                    <option value={"0"}>전체</option>
                    <option value={"1"}>이름</option>
                </select>
                <input
                    type="text"
                    className="form-control w-250px ms-5px h-34px"
                    {...register("keyword")}
                />
                <button type="submit" className="btn btn-info btn_search w-80px ms-5px">
                    <img
                        src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"}
                        alt=""
                    />
                    조회
                </button>
            </form>

            <table className="table table-bordered my_table table_modal"   style={{ tableLayout: "fixed", width: "100%" }}>
                <thead>
                <tr>
                    <th style={{ width: "55px" }}></th>
                    <th style={{ width: "275px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>이름</th>
                    <th style={{ width: "360px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>유저 ID</th>
                    <th style={{ width: "406px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>기본 메일 주소</th>
                </tr>
                </thead>
                <tbody>
                {(data as SystemUserMapType)?.systemUserList?.length === 0 ? (
                    <EmptyTableRow/>
                ) : (
                    (data as SystemUserMapType)?.systemUserList?.map((item: any) => {
                        return (
                            <tr className={`clickable ${item.systemuserid === selectItem?.systemuserid ? "lightblue" : ""}`}
                                onClick={() => setSelectItem(item)}>
                                <td>
                                    <div className="checkbox_outer">
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            onClick={() => {
                                                setSelectItem(item);
                                            }}
                                            checked={
                                                selectItem?.systemuserid === item?.systemuserid
                                            }
                                        />
                                    </div>
                                </td>
                                <td className="text-center">{item?.fullname}</td>
                                <td className="text-center">{item?.systemuserid}</td>
                                <td
                                    className="text-center"
                                    data-tooltip-id="email-tooltip"
                                    data-tooltip-content={item?.internalemailaddress}
                                    style={{
                                        width: "426px",
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                    }}
                                >
                                    {item?.internalemailaddress}
                                </td>


                            </tr>
                        );
                    })
                )}
                </tbody>

                <Tooltip id="email-tooltip" className="custom-tooltip" />
            </table>

            <PaginationSub
                totalCount={(data as SystemUserMapType)?.totalCount ?? 0}
                currentPage={searchOption.pageNo}
                onChangeCallback={(i) =>
                    setSearchOption({...searchOption, pageNo: i})
                }
            />

            <div className="mt-3 d-flex align-items-center justify-content-end">
                <button
                    type="button"
                    className="btn btn-outline-primary w-100px h-38px my-0"
                    onClick={onCancel}
                >
                    취소
                </button>
                <button
                    type="button"
                    className="btn btn-dark w-100px h-38px my-0 ms-3"
                    onClick={onConfirm}
                >
                    선택
                </button>
            </div>
        </>
    );
};
